import type React from 'react';
import type { CookieValues, SetCookieOptions } from '~/hooks/useUtils/useCookies';
import { PageContext } from './PageContext';

interface PageProviderProps {
  children: React.ReactNode;
  cookies: CookieValues;
  setCookie: (options: SetCookieOptions) => void;
  removeCookie: (name: SetCookieOptions['name']) => void;
  cookiesSet?: boolean;
  visitToken?: string;
  referralId?: string;
  currentPath: string;
}

export const PageProvider: React.FC<PageProviderProps> = ({
  cookies,
  setCookie,
  removeCookie,
  cookiesSet,
  children,
  visitToken,
  referralId,
  currentPath,
}) => {
  return (
    <PageContext.Provider
      value={{
        cookies,
        setCookie,
        removeCookie,
        cookiesSet,
        visitToken,
        referralId,
        currentPath,
      }}
    >
      <div className="flex min-h-screen flex-col">{children}</div>
    </PageContext.Provider>
  );
};
